import { FC } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useSnapCarousel } from 'react-snap-carousel';
import { Button } from '../../components/button/Button';
import { CategoryCarouselLink } from './CategoryCarouselLink';
import strings from './home.translations';
import { Category } from '../../services/graph/hooks/sidecar.types';
import { Loader } from '../../components/loading/Loader';
import { useCategories } from '../../services/api/hooks/categories';

export const CategoryCarousel: FC = () => {
  const categories = useCategories();
  const navigate = useNavigate();

  const categoriesInGroups: Category[][] = [];
  // Split into groups of 3
  categories.forEach((category, index) => {
    if (index % 3 === 0) {
      categoriesInGroups.push([]);
    }
    categoriesInGroups[categoriesInGroups.length - 1].push(category);
  });

  const { scrollRef, pages, activePageIndex, next, prev, goTo } = useSnapCarousel();

  const firstPage = activePageIndex === 0;
  const lastPage = activePageIndex === pages.length - 1;

  const onBack = () => {
    if (firstPage) {
      goTo(pages.length - 1);
    } else {
      prev();
    }
  };

  const onNext = () => {
    if (lastPage) {
      goTo(0);
    } else {
      next();
    }
  };

  if (categories.length === 0) {
    return <Loader className="mt-3 w-10 h-10 mx-auto text-primary-800" />;
  } else if (categories.length > 6) {
    return (
      <div className="flex md:gap-2 items-center text-primary-800">
        <button onClick={onBack}>
          <FiChevronLeft className={`h-8 md:h-12 w-8 md:w-12`} />
        </button>
        <div className="flex-1">
          <ul className="flex overflow-auto snap-x snap-mandatory no-scroll-bar" ref={scrollRef}>
            {categoriesInGroups.map(([a, b, c]) => {
              return (
                <li key={a.name} className="flex flex-col gap-2 md:gap-5 w-1/2 flex-none px-1 md:px-2">
                  {a && <CategoryCarouselLink categoryData={a} />}
                  {b && <CategoryCarouselLink categoryData={b} />}
                  {c && <CategoryCarouselLink categoryData={c} />}
                </li>
              );
            })}
          </ul>
          <div className="px-1 md:px-2 mt-2">
            <Button className="w-full" onClick={() => navigate('/documents')}>
              {strings.categories.showAll}
            </Button>
          </div>
        </div>

        <button onClick={onNext}>
          <FiChevronRight className={`h-8 md:h-12 w-8 md:w-12`} />
        </button>
      </div>
    );
  } else {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {categories.map(category => {
          if (!category.id) throw new Error('Category information is missing');
          return <CategoryCarouselLink key={category.id} categoryData={category} />;
        })}
      </div>
    );
  }
};
